module.exports = __webpack_public_path__ + "static/who_we_work_with_2x-ac7854571c274e1abc45d4182a42e6b3.png";